import ResultsServiceModel from '@/models/ResultsServiceModel'

export default class GrowerModel extends ResultsServiceModel {
  modelName () {
    return 'growers'
  }

  defaults () {
    return {
      id: null,
      name: null,
      fields: null
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val)
    }
  }
}
